import { render } from "./ActionType.vue?vue&type=template&id=f2b20306&scoped=true"
import script from "./ActionType.vue?vue&type=script&lang=ts"
export * from "./ActionType.vue?vue&type=script&lang=ts"

import "./ActionType.vue?vue&type=style&index=0&id=f2b20306&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f2b20306"

export default script